var _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h32v32H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 7,
    y: 1.5,
    fill: "#CFD3F7",
    rx: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18 9.5c1.625.16 2.72.524 3.535 1.346C23 12.32 23 14.692 23 19.436s0 7.116-1.465 8.59C20.072 29.5 17.714 29.5 13 29.5s-7.071 0-8.536-1.474S3 24.18 3 19.436s0-7.116 1.464-8.59C5.281 10.024 6.374 9.661 8 9.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 17.5v-8m0 0 3 3m-3-3-3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3 20.5h3.16c.905 0 1.358 0 1.756.21.398.208.692.6 1.281 1.386l.606.808c.589.785.883 1.178 1.281 1.387s.85.209 1.756.209h.32c.905 0 1.358 0 1.756-.21.398-.208.692-.6 1.281-1.386l.606-.808c.589-.785.883-1.178 1.281-1.387s.85-.209 1.756-.209H23"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_1.01346499986a223cc674360ea06a3c6e.svg";